// extracted by mini-css-extract-plugin
export default {"fillList":"BETFillListWidget_fillList__KCaJJ","fillListHeader":"BETFillListWidget_fillListHeader__8tAEx"};